import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { phoneNumberLengthValidator } from 'src/app/utils/utils.common';

@UntilDestroy()

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {
  isShowPassword = false;
  isShowConfirmPassword = false;
  companyForm! : FormGroup
  submitted  = false;
  companyId:any;
  constructor(private fb : FormBuilder,
   private companyService:CompanyService,
   private router: Router,
   private activatedRoute: ActivatedRoute
  ){}

  ngOnInit(): void {
    this.activatedRoute.params
    .pipe(untilDestroyed(this)).subscribe((params) => {
      this.companyId = params["id"];
      if(this.companyId){
        this.getCompanybyId();
      }
    });

    this.companyForm = this.fb.group({
      displayName: ['', Validators.required],
      email: ["", [Validators.required, Validators.email]],
      stateCode: ['', Validators.required],
      address: this.fb.group({   
        name: ['',Validators.required],    
        coords: [[],Validators.required]          
      }),
      timezone: [''],
      dateFormat: [''],
      timeFormat: [''],
      contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      extensionDispatcherNumber: [''],
      companyFaxNumber: [''],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      isActive: [true, Validators.required],
      npiAhcccsPid: [''],
      taxId: [''],
      associateCompanies: [''],
      onboardingStatus: [''],
      trialEnd: [''],
      focalPerson: this.fb.group({
        contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
        displayName: ['',Validators.required],
      }),
      reviewUrl: [''],
      timeInAt: [''],
      cushionBetweenCABreakTime: [''],
      caBreakTimeCaution: [''],
      companyNotes: [''],
      allowTimesheet: [false],
      // allowCamera: [false],
      allowAttendee: [false],
      tripAssistance: [false],
      allowNearBy: [false],
      allowSms: [false],
      alcReminder: [false],
      forcedAcceptTrips: [false],
      iaal: [false],
      // medical: [false],
      calculateLocalMiles: [false],
      showRoute: [false],
      deadMiles: [false],
      skipSignature: [false],
      listView: [false],
      odometerRequired: [false],
      ctcMarketplace: [false],
      cms1500: [false],
      // corporateOdometerRequired: [false],
      caTimesheet: [false],
      associateImage: [false],
      allowUber: [false],
    });
    const payload = this.companyForm.value
    
  }

  get form(){
    return this.companyForm.controls;
  }

  get address() {
    return this.companyForm.controls.address as FormGroup;
  }

  get focalPerson() {
    return this.companyForm.controls.focalPerson as FormGroup;
  }

  onSave(){
      this.submitted = true;
      if (this.companyForm.invalid) {
        return;
      } 
    const payload = this.companyForm.value
    this.companyService.saveComanies(this.companyId, payload).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
        this.router.navigateByUrl('/companies')
      }
    })
  }

  getCompanybyId(){
    this.companyService.getCompanyById(this.companyId).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
      this.companyForm.patchValue({...data})
      }
    })
  }

  togglePassword() {
    this.isShowPassword = !this.isShowPassword;
  }
  toggleConfirmPassword() {
    this.isShowConfirmPassword = !this.isShowConfirmPassword;
  }

}




